import React from 'react';
import { useTranslation } from 'react-i18next';
import FileEarmarkTextIcon from 'components/atoms/icons/file-earmark';

import s from './styles.module.scss';

interface IProps {
  onOpen: () => void;
}

const OutcomeCol: React.FC<IProps> = ({ onOpen }) => {
  const { t } = useTranslation();

  return (
    <button className={s.outcome} onClick={onOpen}>
      <FileEarmarkTextIcon className={s.i} />
      {t('labels.open')}
    </button>
  );
};

export default OutcomeCol;
